export default {
  apiRoot: 'https://app.myinnergenius.com/api/v1/',
  vueLogErrors: false,
  sentryDsn: 'https://b1a4e54a19d049e2af062071ba404925@sentry.atleta.hu/22',
  routerMode: 'history'
}
